import { useQueryHelper } from '@anytag/shared-hooks';
import { useInfluencerWhitelistQuery } from '@anytag/graphql';
import { useMarketplaceDetailsContext } from '../../marketplace-details-context';

export const useMarketplaceInfluencersWhiteList = () => {
  const { marketplaceId } = useMarketplaceDetailsContext();
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { data, loading, networkStatus } = useInfluencerWhitelistQuery({
    fetchPolicy: 'network-only',
    variables: { marketplaceId },
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      navigate({ to: '/marketplace' });
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  return {
    loading: loading && networkStatus === 1,
    influencerWhitelist: data?.influencerWhitelist
  };
};
